import { render, staticRenderFns } from "./template-list-activities.vue?vue&type=template&id=3e5199c4"
import script from "./template-list-activities.vue?vue&type=script&lang=js"
export * from "./template-list-activities.vue?vue&type=script&lang=js"
import style0 from "./template-list-activities.vue?vue&type=style&index=0&id=3e5199c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports